import React from 'react';

import PropTypes from 'prop-types';

import { useUser } from 'hooks';

// Components
import { Mui } from 'components';
import { NavBar as DefaultNavBar } from 'components/layouts';

function NavBar({ onMobileClose, openMobile, ...restProps }) {
  // Custom hooks
  const { user } = useUser();

  // Constants
  const { picture, firstName, lastName, email } = user;

  // Props
  const profile = {
    image: picture,
    displayName: [firstName, lastName].join(' '),
    profileUrl: '/accounts',
    info: email,
  };

  const items = [
    {
      subheader: 'Minha conta',
      items: [
        {
          title: 'Início',
          href: '/accounts',
          icon: newProps => <Mui.Icon {...newProps}>home</Mui.Icon>,
        },
        {
          title: 'Meu perfil',
          href: '/accounts/profile',
          icon: newProps => <Mui.Icon {...newProps}>account_circle</Mui.Icon>,
        },
        {
          title: 'Alterar senha',
          href: '/accounts/change-password',
          icon: newProps => <Mui.Icon {...newProps}>lock</Mui.Icon>,
        },
      ],
    },
    {
      subheader: 'Outros',
      items: [
        {
          title: 'Sair',
          href: '/logout',
          icon: newProps => <Mui.Icon {...newProps}>exit_to_app</Mui.Icon>,
        },
      ],
    },
  ];

  return (
    <DefaultNavBar
      onMobileClose={onMobileClose}
      openMobile={openMobile}
      items={items}
      profile={profile}
      {...restProps}></DefaultNavBar>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
